// Sign-in methods that require the `email_verified` field to be true for successful authentication.
import type { P0User } from "../types/index.ts";

// See https://firebase.google.com/docs/rules/rules-and-auth
export const VERIFIED_EMAIL_REQUIRED = ["custom", "password", "phone"];

/** True when a user is a gateway OAuth server self-authenticating with its
 * own self-signed JWT (`sub` equal to its own `iss`), rather than a human or
 * an agent identity it has minted a token for. */
export const isGatewaySelfAuth = (user: {
  iss?: string;
  uid: string;
}): boolean => typeof user.iss === "string" && user.iss === user.uid;

/** True if and only if the user is agentic and auth was initiated by the agent itself. */
export const isHeadlessAgentAuth = (user: P0User): boolean =>
  // Headless agents are their own subject
  user.actors?.at(-1)?.sub === user.uid;
